module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-modal c-modal--reward-order t-modal"
  }, [_c('section', {
    staticClass: "c-modal__box c-modal--reward-order__box"
  }, [_c('div', {
    staticClass: "c-modal--reward-order__box__content"
  }, [_c('div', {
    staticClass: "c-modal--reward-order__points-cost"
  }, [_c('h2', {
    staticClass: "c-modal--reward-order__points-cost__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.modal_title')))]), _vm._v(" "), _c('p', {
    staticClass: "c-modal--reward-order__points-cost__data"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v(" "), _c('vue-numeric', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.priceOutOfRange),
      expression: "!priceOutOfRange"
    }],
    staticClass: "c-modal--reward-order__points-cost__data__number",
    attrs: {
      "separator": ",",
      "read-only": true,
      "value": _vm.totalPrice
    }
  }), _vm._v(" "), (_vm.priceOutOfRange) ? _c('span', [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.invalid_amount')))]) : _vm._e()], 1)]), _vm._v(" "), (_vm.hasRange) ? _c('h2', {
    staticClass: "c-modal--reward-order__shipping-info__h2 reward_name"
  }, [_vm._v(_vm._s(_vm.rewardDetails.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__points-cost quantity_container"
  }, [(_vm.hasRange) ? _c('div', [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__h2 quantity_label"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v(_vm._s(_vm.rewardDetails['supplier_items'][0]['currency']) + " " + _vm._s(_vm.$t('web.catalog_order_modal.amount')))]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "c-modal--reward-order__points-cost__data__number",
    attrs: {
      "separator": ",",
      "currency": _vm.rewardDetails['supplier_items'][0]['currency']
    },
    model: {
      value: (_vm.dollarPriceInserted),
      callback: function($$v) {
        _vm.dollarPriceInserted = $$v
      },
      expression: "dollarPriceInserted"
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'c-validation t-alert-danger': _vm.priceOutOfRange
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_order_modal.default_dollar_amount_message', {
    min_price: _vm.minDefDollarPrice,
    max_price: _vm.maxDefDollarPrice
  })) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.hasRange) ? _c('h2', {
    staticClass: "c-modal--reward-order__shipping-info__h2 reward_name"
  }, [_vm._v(_vm._s(_vm.rewardDetails.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "quantity_select_container"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__h2 quantity_label"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.quantity')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quantity),
      expression: "quantity"
    }],
    staticClass: "c-modal--reward-order__points-cost__data quantity_select",
    attrs: {
      "name": "quantity",
      "tabindex": "5"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.quantity = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((25), function(n) {
    return _c('option', {
      key: n,
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__math"
  }, [_c('dl', {
    staticClass: "c-modal--reward-order__math__dl"
  }, [_c('dd', {
    staticClass: "c-modal--reward-order__math__dl__number"
  }, [_c('vue-numeric', {
    attrs: {
      "separator": ",",
      "read-only": true
    },
    model: {
      value: (_vm.participant.points_balance),
      callback: function($$v) {
        _vm.$set(_vm.participant, "points_balance", $$v)
      },
      expression: "participant.points_balance"
    }
  })], 1), _vm._v(" "), _c('dt', {
    staticClass: "c-modal--reward-order__math__dl__description"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_order_modal.current_points')) + "\n          ")])]), _vm._v(" "), _c('dl', {
    staticClass: "c-modal--reward-order__math__dl"
  }, [_c('dd', {
    staticClass: "c-modal--reward-order__math__dl__number"
  }, [_c('strong', [_vm._v("\n              –\n              "), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "read-only": true,
      "value": _vm.totalPrice
    }
  })], 1)]), _vm._v(" "), _c('dt', {
    staticClass: "c-modal--reward-order__math__dl__description t-headline"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_order_modal.reward_cost')) + "\n          ")])]), _vm._v(" "), _c('dl', {
    staticClass: "c-modal--reward-order__math__dl"
  }, [_c('dd', {
    staticClass: "c-modal--reward-order__math__dl__number"
  }, [_c('i', {
    staticClass: "fa fa-star t-points-icon"
  }), _vm._v(" "), _c('vue-numeric', {
    attrs: {
      "separator": ",",
      "read-only": true
    },
    model: {
      value: (this.pointsBalance),
      callback: function($$v) {
        _vm.$set(this, "pointsBalance", $$v)
      },
      expression: "this.pointsBalance"
    }
  })], 1), _vm._v(" "), _c('dt', {
    staticClass: "c-modal--reward-order__math__dl__description"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_order_modal.points_left')) + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__note"
  }, [_c('i18n', {
    staticClass: "u-small-paragraph u-center-text u-no-margins",
    attrs: {
      "path": "web.catalog_order_modal.address_confirmation",
      "tag": "p"
    },
    scopedSlots: _vm._u([{
      key: "profile_link",
      fn: function() {
        return [_c('router-link', {
          staticClass: "t-link",
          attrs: {
            "to": {
              name: 'Settings'
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.address_confirmation_link')))])]
      },
      proxy: true
    }])
  }), _vm._v(" "), (_vm.showGiftCardMessage) ? _c('p', {
    staticClass: "u-small-paragraph u-center-text u-no-margins"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "text-transform": "uppercase"
    }
  }, [_vm._v("**"), _c('u', [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.important')))])]), _vm._v(": \n            " + _vm._s(_vm.$t('web.catalog_order_modal.gift_card_cancellation_message')) + "\n          ")])]) : _vm._e()], 1), _vm._v(" "), (!_vm.editingAddress) ? _c('div', {
    staticClass: "c-modal--reward-order__shipping-info"
  }, [_c('div', {
    staticClass: "c-modal--reward-order__shipping-info__buttons\n                    c-modal--reward-order__shipping-info__buttons--default-mode"
  }, [_c('button', {
    staticClass: "c-button",
    on: {
      "click": function($event) {
        _vm.editingAddress = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.edit_button')))])]), _vm._v(" "), _c('h2', {
    staticClass: "c-modal--reward-order__shipping-info__h2"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_info')))]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_first_name')))]), _vm._v(" "), (_vm.participant.shipping_first_name) ? _c('p', {
    staticClass: "u-paragraph"
  }, [_vm._v(_vm._s(_vm.participant.shipping_first_name))]) : _c('p', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.not_entered')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_last_name')))]), _vm._v(" "), (_vm.participant.shipping_last_name) ? _c('p', {
    staticClass: "u-paragraph"
  }, [_vm._v(_vm._s(_vm.participant.shipping_last_name))]) : _c('p', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.not_entered')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_address')))]), _vm._v(" "), (!_vm.addressEmpty) ? _c('address', {
    staticClass: "u-paragraph"
  }, [_vm._v("\n            " + _vm._s(_vm.participant.shipping_address1)), _c('br'), _vm._v("\n            " + _vm._s(_vm.participant.shipping_address2)), _c('br'), _vm._v("\n            " + _vm._s(_vm.participant.shipping_city) + ", " + _vm._s(_vm.participant.shipping_state) + " " + _vm._s(_vm.participant.shipping_zip_code)), _c('br'), _vm._v("\n            " + _vm._s(_vm.getDropdownLabel(_vm.participant.shipping_country, _vm.metadata.shipping_country.options)) + "\n          ")]) : _c('address', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('web.catalog_order_modal.not_entered')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_email')))]), _vm._v(" "), (_vm.participant.shipping_email) ? _c('p', {
    staticClass: "u-paragraph u-force-wrap"
  }, [_vm._v(_vm._s(_vm.participant.shipping_email))]) : _c('p', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.not_entered')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('h3', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_phone')))]), _vm._v(" "), (_vm.participant.shipping_phone) ? _c('p', {
    staticClass: "u-paragraph"
  }, [_vm._v(_vm._s(_vm.participant.shipping_phone))]) : _c('p', {
    staticClass: "u-paragraph u-paragraph--empty-field"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.not_entered')))])])]) : _vm._e(), _vm._v(" "), (_vm.editingAddress) ? _c('div', {
    staticClass: "c-modal--reward-order__shipping-info"
  }, [_c('h2', {
    staticClass: "c-modal--reward-order__shipping-info__h2"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_info')))]), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info"
  }, [_c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_first_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_first_name')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_first_name),
      expression: "participant.shipping_first_name"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_first_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.shipping_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_first_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info"
  }, [_c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_last_name')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_last_name),
      expression: "participant.shipping_last_name"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_last_name",
      "tabindex": "1"
    },
    domProps: {
      "value": (_vm.participant.shipping_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_last_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info-address__city-state-zip"
  }, [_c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_address1"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_address1')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_address1),
      expression: "participant.shipping_address1"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_address1",
      "tabindex": "2"
    },
    domProps: {
      "value": (_vm.participant.shipping_address1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_address1", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_address1), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  }), _vm._v(" "), _c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_address2"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_address2')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_address2),
      expression: "participant.shipping_address2"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_address2",
      "tabindex": "3"
    },
    domProps: {
      "value": (_vm.participant.shipping_address2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_address2", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_address2), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  }), _vm._v(" "), _c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_city"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_city')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_city),
      expression: "participant.shipping_city"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_city",
      "tabindex": "4"
    },
    domProps: {
      "value": (_vm.participant.shipping_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_city", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_city), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  }), _vm._v(" "), _c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_state"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_state')) + "*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_state),
      expression: "participant.shipping_state"
    }],
    attrs: {
      "name": "shipping_state",
      "tabindex": "5"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "shipping_state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.shipping_state.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.shipping_state), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  }), _vm._v(" "), _c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_zip_code"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_zip')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_zip_code),
      expression: "participant.shipping_zip_code"
    }],
    attrs: {
      "type": "text",
      "maxlength": "6",
      "name": "shipping_zip_code",
      "tabindex": "6"
    },
    domProps: {
      "value": (_vm.participant.shipping_zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_zip_code", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_zip_code), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  }), _vm._v(" "), _c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_country"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_country')) + "*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_country),
      expression: "participant.shipping_country"
    }],
    attrs: {
      "name": "shipping_country",
      "tabindex": "7"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.participant, "shipping_country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.metadata.shipping_country.options), function(item) {
    return _c('option', {
      domProps: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2), _vm._v(" "), _vm._l((_vm.errors.shipping_country), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_email"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_email')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_email),
      expression: "participant.shipping_email"
    }],
    attrs: {
      "type": "email",
      "name": "shipping_email",
      "tabindex": "8"
    },
    domProps: {
      "value": (_vm.participant.shipping_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__field"
  }, [_c('label', {
    staticClass: "c-modal--reward-order__shipping-info__field__h3",
    attrs: {
      "for": "shipping_phone"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.shipping_phone')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participant.shipping_phone),
      expression: "participant.shipping_phone"
    }],
    attrs: {
      "type": "text",
      "name": "shipping_phone",
      "tabindex": "9"
    },
    domProps: {
      "value": (_vm.participant.shipping_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.participant, "shipping_phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.shipping_phone), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__shipping-info__buttons\n                    c-modal--reward-order__shipping-info__buttons--edit-mode"
  }, [_c('button', {
    staticClass: "c-button",
    attrs: {
      "tabindex": "10"
    },
    on: {
      "click": function($event) {
        return _vm.reset()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.cancel_button')))]), _vm._v(" "), _c('button', {
    staticClass: "c-button t-button-primary",
    attrs: {
      "tabindex": "11"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_order_modal.save_button')))])])]) : _vm._e()]), _vm._v(" "), (_vm.shippingIncomplete) ? _c('div', [_c('div', {
    staticClass: "c-form-validation t-alert-warning"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('web.catalog_order_modal.incomplete_shipping_warning')) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "c-modal--reward-order__actions"
  }, [_c('button', {
    staticClass: "c-button c-modal--reward-order__actions__button t-button-plain",
    attrs: {
      "disabled": _vm.confirming
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.catalog_order_modal.cancel_button')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "c-button c-modal--reward-order__actions__button t-button-primary",
    attrs: {
      "disabled": _vm.confirming || _vm.shippingIncomplete || _vm.editingAddress || _vm.notEnoughPoints || _vm.priceOutOfRange
    },
    on: {
      "click": function($event) {
        return _vm.confirm()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('web.catalog_order_modal.redeem_button')) + "\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "c-modal__overlay"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-566da34e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/OrderModal.vue
// module id = 535
// module chunks = 1